import Tab from '@components/tabs/secondary'
import React, { Fragment } from 'react'
import Request from './request'
import Recieve from './receive'

const Withdrawals = () => {
  const items = [
    { label: 'Requests', component: Request },
    { label: 'Received', component: Recieve },
  ]
  return (
    <Fragment>
      <Tab items={items} />
    </Fragment>
  )
}

export default Withdrawals
